import { render, staticRenderFns } from "./TheExampleCard.vue?vue&type=template&id=1c529459&scoped=true&"
import script from "./TheExampleCard.vue?vue&type=script&lang=ts&"
export * from "./TheExampleCard.vue?vue&type=script&lang=ts&"
import style0 from "./TheExampleCard.vue?vue&type=style&index=0&id=1c529459&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c529459",
  null
  
)

export default component.exports